import styled from 'styled-components';

export const SubHeading = styled.h2`
  font-family: ${({ theme }) => theme.headerFont};
  font-weight: normal;
  font-size: 24px;
  text-align: left;
`;

export const JourneyWrapper = styled.div`
  padding-top: 40px;
`;
